export function WrapperCard({ children, renderTop, className = '', classNameChildren = '' }) {
  return (
    <div className={`rounded-3xl border border-[#233636] bg-[#022424] overflow-hidden ${className}`}>
      {renderTop && <div className="border-b border-[#233636] px-4 py-3 text-white/70">{renderTop()}</div>}
      <div className={`m-4 ${classNameChildren}`}>{children}</div>
    </div>
  );
}
